import React from 'react';
import config from "../config";
import {withStyles} from '@material-ui/core/styles';
import logoWhite from '../assets/images/logo-white.png';
import {Link} from "react-router-dom";
import {loginSuccess} from "../state/actions/auth";
import {connect} from 'react-redux';
import {fetchBusiness} from "../state/actions/business";


export class BusinessHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: true,
    };
  }

  toggleNavbar = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  componentDidMount() {
    // Check if user is logged in already
    // This probably should be in a higher app container, but this will do for now
    const token = window.localStorage.getItem('authToken');
    if (token) {
      this.props.loginSuccess(token);
      this.props.fetchBusiness();
    }
  }

  render() {
    const {classes} = this.props;
    const loggedIn = !!this.props.auth.token;
    const business = this.props.business;

    const collapsed = this.state.collapsed;
    const classOne = collapsed ? 'collapse navbar-collapse' : 'collapse navbar-collapse show';
    const classTwo = collapsed ? 'navbar-toggler navbar-toggler-right collapsed' : 'navbar-toggler navbar-toggler-right';

    return (
      <nav className={`${classes.navBar} navbar navbar-dark navbar-expand-lg`}>
        <Link className="navbar-brand" to={config.routes.home}>
          <img className={classes.navLogo} src={logoWhite}/>
        </Link>
        <button onClick={this.toggleNavbar} className={`${classTwo}`} type="button"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className={`${classes.navBarTogglerIcon} navbar-toggler-icon`}/>
        </button>
        <div className={`${classOne} justify-content-end`} id="navbarSupportedContent">
          <ul className="navbar-nav">
            <li className="nav-item">
              <Link className={`${classes.navLink} nav-link`} to={config.routes.businessFaq}>FAQ</Link>
            </li>
            <li className="nav-item">
              <Link className={`${classes.navLink} nav-link`} to={config.routes.businessPricing}>Pricing</Link>
            </li>
            <li className="nav-item">
              <Link className={`${classes.navLink} nav-link`} to={config.routes.contact}>Contact</Link>
            </li>
            <li className="nav-item">
              {!loggedIn &&
              <Link className={`${classes.navLink} nav-link`} to={config.routes.businessLogin}>Login</Link>}
              {loggedIn && business &&
              <Link className={`${classes.navLink} nav-link`} to={'/' + business.slug}>Dashboard &#10142;</Link>}
            </li>
            <li className="nav-item">
              {!loggedIn &&
              <Link className={`${classes.navLink} nav-link`} to={config.routes.businessSignUp}>Sign Up</Link>}
            </li>
          </ul>
        </div>
      </nav>
    )
  }
}


const styles = (theme) => ({
  navBarTogglerIcon: {
    // backgroundColor: 'red',
  },
  navBar: {
    padding: '15px 0 30px',
    [theme.breakpoints.up('md')]: {
      padding: '15px 0 0',
    }
  },
  navLogo: {
    height: '40px',
  },
  navLink: {
    color: '#ffffff !important',
  },
});

export default connect(state => ({
  auth: state.auth,
  business: state.business.item,
}), dispatch => ({
  loginSuccess: (token) => dispatch(loginSuccess(token)),
  fetchBusiness: () => dispatch(fetchBusiness()),
}))(withStyles(styles)(BusinessHeader));


class Nav extends React.Component {
  constructor(props) {
    super(props);
    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true,
    };
  }
  toggleNavbar() {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  }
  render() {
    const collapsed = this.state.collapsed;
    const classOne = collapsed ? 'collapse navbar-collapse' : 'collapse navbar-collapse show';
    const classTwo = collapsed ? 'navbar-toggler navbar-toggler-right collapsed' : 'navbar-toggler navbar-toggler-right';
    return (
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark transparent-nav">
        <div className="container">
          <a className="navbar-brand" href="#">Rate My Neighborhood</a>
          <button onClick={this.toggleNavbar} className={`${classTwo}`} type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon" />
          </button>
          <div className={`${classOne}`} id="navbarResponsive">
            <ul className="navbar-nav ml-auto">
              <li className="nav-item active">
                <Link className="nav-link" to="/">Home</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/about">About</Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}
// export default Nav;



// WEBPACK FOOTER //
// ./src/parts/BusinessHeader.js